export const SUPPORTED_LOCALES = [
  'ko',
  'en',
  'vi',
  'th',
  'uz',
  'ne',
  'my',
  'km',
  'id',
  'tl',
  'zh',
] as const;

export type Locale = (typeof SUPPORTED_LOCALES)[number];

export const DEFAULT_LOCALE: Locale = 'ko';

export const LOCALE_LABELS: Record<Locale, { native: string; ko: string; flag: string }> = {
  ko: { native: '한국어', ko: '한국어', flag: '🇰🇷' },
  en: { native: 'English', ko: '영어', flag: '🇺🇸' },
  vi: { native: 'Tiếng Việt', ko: '베트남어', flag: '🇻🇳' },
  th: { native: 'ไทย', ko: '태국어', flag: '🇹🇭' },
  uz: { native: "O'zbekcha", ko: '우즈벡어', flag: '🇺🇿' },
  ne: { native: 'नेपाली', ko: '네팔어', flag: '🇳🇵' },
  my: { native: 'မြန်မာ', ko: '미얀마어', flag: '🇲🇲' },
  km: { native: 'ខ្មែរ', ko: '캄보디아어', flag: '🇰🇭' },
  id: { native: 'Bahasa Indonesia', ko: '인도네시아어', flag: '🇮🇩' },
  tl: { native: 'Filipino', ko: '필리핀어', flag: '🇵🇭' },
  zh: { native: '中文', ko: '중국어', flag: '🇨🇳' },
};

export function isSupportedLocale(value: string | null | undefined): value is Locale {
  return SUPPORTED_LOCALES.includes(value as Locale);
}

/** navigator.language → 지원 locale 매핑. 'vi-VN' → 'vi', 'zh-CN' → 'zh', 'fil-PH' → 'tl' */
export function detectLocaleFromNavigator(): Locale {
  if (typeof navigator === 'undefined') return DEFAULT_LOCALE;
  const langs = navigator.languages ?? [navigator.language];
  for (const raw of langs) {
    const base = raw.toLowerCase().split('-')[0];
    if (base === 'fil') return 'tl';
    if (isSupportedLocale(base)) return base;
  }
  return DEFAULT_LOCALE;
}
